module.exports = __webpack_public_path__ + "static/media/file-icon.d07c9186.svg";